<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <h1>Featured Organization</h1>
        <Organization :organization="featuredOrganization" />
      </v-col>
    </v-row>
    <v-row>
      <OrganizationList />
    </v-row>
  </v-container>
</template>

<script>
  import OrganizationList from './OrganizationList.vue'
  import Organization from './Organization.vue'

  export default {
    name: 'Home',

    components: {
      OrganizationList,
      Organization
    },

    data: () => ({
      featuredOrganization: {
        name: 'Seniors Coalition'
      }
    })
  }
</script>
